module.exports = __webpack_public_path__ + "img/bg.4439c6b3.jpeg";